// ABOUTME: The segment's coaching scheduling prompt: instructions, the choose-time button, contacts
// ABOUTME: Shared by FreeBusy, which binds the button by id, and the Nylas picker via onClick
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../Translations';
import DateCheckIcon from '../Cutesies/DateCheckIcon';
import * as style from './style.module.css';

interface Props {
  buttonId: string;
  onClick: () => void;
}

const CoachingReadyView: React.FC<Props> = ({ buttonId, onClick }) => (
  <div className={style.ready}>
    <p>
      <T kind="Click the “Choose Day and Time” button ..." />
    </p>
    <div className={style.buttonContainer}>
      <button
        id={buttonId}
        className={style.button}
        onClick={onClick}
        data-intercom-target="coaching-choose-time-button"
      >
        <T
          kind="Choose <fragment>Day</fragment> and Time"
          fragment={(content) => <span className={style.desktopOnly}>{content}</span>}
        />
        <div className={style.buttonIcon}>
          <DateCheckIcon />
        </div>
      </button>
    </div>
    <div className={style.notice}>
      <p>
        <T
          kind="Questions? Email us at <emailAddress/>."
          emailAddress={
            <a className={style.mailToLink} href="mailto:coaching@execonline.com">
              coaching@execonline.com
            </a>
          }
        />
      </p>
      <p>
        <T kind="If you need to modify or cancel the time of the session, we ..." />
      </p>
    </div>
  </div>
);

export default observer(CoachingReadyView);
